import type { Guide } from '../types';

/**
 * S-26.10-16 — pytanie do klienta przy prezleceniu i przypomnienia o niewysłanym (scenariusz e2e 34; prace 26.10.2026,
 * pakiet P1). Rekordy: prezlecenia P1Q (z brakami) i P1S (pytanie wysłane) z `scenario-state.mjs` (`p1`).
 */
export const guide: Guide = {
  flagKey: 'clientQuestions',
  title: 'Pytanie do klienta przy prezleceniu i przypomnienia o niewysłanym',
  whatItDoes:
    'Na karcie prezlecenia CS zaznacza brakujące pola, a aplikacja przygotowuje szkic pytania do klienta z adresatem z kartoteki. CS wysyła je ze swojej poczty i oznacza „Wysłane ręcznie”; od tej chwili pytanie czeka na odpowiedź, którą CS wpisuje, gdy przyjdzie. Kolejka CS i pulpit przyjęcia zleceń przypominają o niewykonanej awizacji, niewysłanej aktualizacji i niewysłanym pytaniu po terminie (domyślnie 60 minut, parametr z historią). Z aplikacji nic nie jest wysyłane.',
  audience: ['CS'],
  presentationItems: ['S-26.10-16'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: { description: 'prezlecenie z brakami', listPath: '/pre-orders' },
      target: 'client-question-form',
      mockupTestId: 'cs-zlecenie-pytanie-klient',
      title: 'Przygotuj pytanie do klienta',
      description:
        'Zaznaczasz pola, o które pytasz — braki prezlecenia są zaznaczone od razu — i sprawdzasz adresata z kartoteki kontrahenta.',
      action: 'Kliknij „Przygotuj pytanie do klienta”, zaznacz pola i kliknij „Przygotuj szkic”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'p1.questionPreOrderId' },
        actions: [{ kind: 'click', target: 'cs-zlecenie-pytanie-klient' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: { description: 'prezlecenie z wysłanym pytaniem', listPath: '/pre-orders' },
      target: 'client-question-sent-marker',
      title: 'Pytanie wysłane — czeka na odpowiedź',
      description:
        'Po „Wysłane ręcznie” prezlecenie ma znacznik „Pytanie do klienta wysłane”. Gdy klient odpowie, przepisujesz odpowiedź; dane poprawiasz przez „Popraw dane” ze źródłem ustalenia.',
      action: 'Wpisz odpowiedź klienta i kliknij „Wpisz odpowiedź”.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'p1.sentQuestionPreOrderId' } },
    },
    {
      route: '/intake-dashboard',
      target: 'intake-tile-clientMessagesOverdue',
      title: 'Przypomnienia na pulpicie',
      description:
        'Kafelek „Przypomnienia — po terminie, niewykonane” prowadzi do kolejki CS zawężonej do spraw po terminie: awizacji, aktualizacji i pytań.',
      action: 'Na pulpicie przyjęcia zleceń kliknij kafelek „Przypomnienia”.',
      recorder: { account: 'cs' },
    },
    {
      route: '/cs-queue',
      target: 'cs-queue',
      title: 'Kolejka CS: przypomnienia',
      description:
        'Sprawy po terminie są pilne z powodem „przypomnienie: po terminie, niewykonane”; z kafelka lista pokazuje tylko je. Ponawiania wysyłki z aplikacji nie ma — wysyłasz sam i oznaczasz.',
      action: 'Otwórz sprawę z listy albo usuń filtr przypomnień, żeby zobaczyć całą kolejkę.',
      recorder: { account: 'cs' },
    },
  ],
};
